import React from 'react';
import {
    _cs,
    getHexFromString,
    getColorOnBgColor,
} from '@togglecorp/fujs';
import memoize from 'memoize-one';

import styles from './styles.scss';

interface Props {
    className?: string;
    imgSrc?: string;
    altText: string;
}

export default class DisplayPicture extends React.PureComponent<Props> {
    private getRenderData = memoize((altText: string) => {
        const backgroundColor = getHexFromString(altText);
        const textColor = getColorOnBgColor(backgroundColor);

        return {
            altLetter: altText.substring(0, 1),
            backgroundColor,
            textColor,
        };
    })

    public render() {
        const {
            className,
            imgSrc,
            altText,
        } = this.props;

        const {
            altLetter,
            backgroundColor,
            textColor,
        } = this.getRenderData(altText);

        return (
            <div
                className={_cs(styles.displayPicture, className)}
                style={!imgSrc ? ({ backgroundColor, color: textColor }) : undefined}
            >
                { imgSrc ? (
                    <img
                        className={styles.image}
                        src={imgSrc}
                        alt={altLetter}
                    />
                ) : (
                    <div className={styles.altLetterIcon}>
                        { altLetter }
                    </div>
                )}
            </div>
        );
    }
}
